export default "__VITE_ASSET__BP0dKk4c__"